import { DBAppointmentStatus } from '@prisma/client';
import { AppointmentReq, CheckAppointmentsRes, Resource } from '@tyrio/dto';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { EventProps, EventType } from './types';
import { daysOfWeek } from './constants';
import _ from 'lodash';

export function findOverlappingEvent(
  startTime: Date,
  endTime: Date,
  events: EventProps[]
) {
  const startMoment = moment(startTime, 'HH:mm');
  const endMoment = moment(endTime, 'HH:mm');

  for (let i = 0; i < events.length; i++) {
    const eventStart = moment(events[i].start, 'HH:mm');
    const eventEnd = moment(events[i].end, 'HH:mm');

    if (
      (startMoment.isSameOrAfter(eventStart) &&
        startMoment.isBefore(eventEnd)) ||
      (endMoment.isAfter(eventStart) && endMoment.isSameOrBefore(eventEnd)) ||
      (startMoment.isSameOrBefore(eventStart) &&
        endMoment.isSameOrAfter(eventEnd))
    ) {
      const difference = endMoment.diff(eventStart, 'minutes');
      return { difference: difference, event: events[i] };
    }
  }

  return { difference: 0, event: null };
}

export function _appointment(start: string, end: string) {
  return {
    id: uuidv4(),
    status: DBAppointmentStatus.IN_PROCESS,
    appointmentDateFrom: start,
    appointmentDateTo: end,
    createdBy: `auto-generated`,
    createdAt: moment().toString(),
    vehicleInfo: {
      year: '',
      brand: '',
      model: '',
      licensePlateNumber: '',
    },
    remark: '',
    services: {},
    reservedBox: {
      id: '',
      meta: {},
    },
    expectedDurationTime: end,
    orderReference: 'in-progress',
    customer: {
      firstName: '',
      lastName: '',
      phoneNumberDetails: '',
    },
    serviceType: {
      id: '',
      name: '',
    },
  } as CheckAppointmentsRes;
}

export function range(start: number, end: number) {
  const result = [];
  for (let i = start; i <= end; i++) {
    let number = '';
    if (i <= 9) number = `0${i}:00`;
    else number = `${i}:00`;

    result.push(number);
  }
  return result;
}

export const addTime = (date: Date, time: { h: number; m?: number }) => {
  const timeTemp = moment(date);

  const { h, m } = time;

  timeTemp.hour(h);
  timeTemp.minute(m ?? 0);
  timeTemp.second(0);
  timeTemp.millisecond(0);

  return timeTemp;
};

export function getMinMaxDate(
  date: Date,
  minMaxHour: { min: number; max: number },
  resources: Record<string, Resource>
) {
  let minDate = moment();
  let maxDate = moment();

  if (!_.isEmpty(resources)) {
    const { min, max } = minMaxHour;
    minDate = addTime(date, { h: min });
    maxDate = addTime(date, { h: max });
  }
  return { minDate, maxDate };
}

export function _break(
  start: moment.Moment,
  end: moment.Moment,
  resourceId: string,
  isBreak: boolean
) {
  return {
    appointment: _appointment(start.toString(), end.toString()),
    resourceId: resourceId,
    source: (isBreak ? 'break' : 'disabled') as EventType,
    start: start.toDate(),
    end: end.toDate(),
    isOverlap: false,
    isCurrentUser: false,
  };
}

export const getDayOfWeek = (date: Date): string => {
  return daysOfWeek[date.getDay()];
};

export const _hm = (time: string) => {
  const splitted = time.split(':');

  const h = parseInt(splitted[0]);
  const m = parseInt(splitted[1]);

  return { h, m };
};

export function hasEventsWithinHour(
  targetDateTime: Date,
  events: EventProps[]
) {
  const startHour = moment(targetDateTime).hour();
  const endHour = moment(targetDateTime).add(1, 'hour').hour();

  const date1 = addTime(targetDateTime, { h: startHour, m: 10 });
  const date2 = addTime(targetDateTime, { h: endHour, m: 0 });

  return events.filter((event) => {
    const eventStart = moment(event.start);
    const eventEnd = moment(event.end);
    return (
      (eventStart.isSameOrAfter(date1) && eventStart.isSameOrBefore(date2)) ||
      (eventEnd.isSameOrAfter(date1) && eventEnd.isSameOrBefore(date2))
    );
  });
}

export const getSelectedAppointmentInfo = (
  appointmentDetails: Record<string, string>,
  selectedAppointment: string | null
) => {
  if (!_.isUndefined(appointmentDetails) && selectedAppointment !== null)
    return (
      (_.get(
        appointmentDetails?.['appointments'],
        selectedAppointment as string
      ) as AppointmentReq) ?? null
    );

  return null;
};
